import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Features from './components/Features';
import Contact from './components/Contact';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/ead4752b-4d24-4a1f-a373-9175a6ac4a87.png" 
                alt="JUMI S.R.L. Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className={`text-xl font-light tracking-wide transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
                JUMI S.R.L.
              </span>
            </div>
            <div className="flex gap-8">
              {['Home', 'About', 'Products', 'Features', 'Contact'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className={`text-sm font-medium transition-colors cursor-pointer hover:opacity-70 ${scrolled ? 'text-gray-700' : 'text-white/90'}`}
                >
                  {item}
                </a>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Products />
      <Features />
      <Contact />
    </div>
  );
}
